// extracted by mini-css-extract-plugin
export default {"yib_right":"index_yib_right_7R5bd","title_03c":"index_title_03c_aH0eC","clearfix":"index_clearfix_OcYdc","courier":"index_courier_vqGVL"};